import { ref } from 'vue'

// Fork de useHiddenFluxos.ts (Chatwoot, fluxo_id numérico) pro WootDash nativo — o fluxo
// aqui é identificado por Guid real (wootdashSla.ts::listFlows), não pelo FLUXO_MAP
// hardcoded antigo. Mesmo padrão de preferência local (localStorage, sem sincronia entre
// abas de propósito) — controlada pelo mesmo select "Esconder Fluxo" no DashHeader.vue, atrás
// da permKey dashboard.hideFluxo. Sem o "fluxo sempre escondido por padrão" que o antigo tinha
// (era uma regra específica do fluxo_id 1 do Chatwoot, sem equivalente confirmado aqui).
//
// O filtro vale no servidor (excludeFlowIds em listConversations), então KPIs/totais também
// respeitam. isFluxoHiddenCp fica pros eventos em tempo real que chegam um a um.
const STORAGE_KEY = 'wootdash_hidden_fluxos'
const GENERAL_STORAGE_KEY = 'wootdash_general_fluxo_id'
// Chaves de antes do rename ChatPlatform → WootDash (2026-10-13) — lidas só se a nova ainda
// não existe, pra ninguém perder a preferência na troca.
const LEGACY_STORAGE_KEY = 'chatplatform_hidden_fluxos'
const LEGACY_GENERAL_STORAGE_KEY = 'chatplatform_general_fluxo_id'
/** Fluxo "Geral" — conversa sem fluxo definido conta como dele (mesma regra do backend,
 * ListConversationsCommandHandler.GeneralFlowNumber). */
export const GENERAL_FLOW_NUMBER = 1

function loadInitial(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(LEGACY_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

function loadGeneralFlowId(): string {
  try { return localStorage.getItem(GENERAL_STORAGE_KEY) ?? localStorage.getItem(LEGACY_GENERAL_STORAGE_KEY) ?? '' } catch { return '' }
}

export const hiddenFluxoIdsCp = ref<string[]>(loadInitial())
// Guid do fluxo Geral — vem do catálogo de fluxos (DashHeader.vue carrega no mount); guardado
// localmente pra já valer antes do catálogo chegar.
const generalFlowIdCp = ref<string>(loadGeneralFlowId())

export function setHiddenFluxoIdsCp(ids: string[]): void {
  hiddenFluxoIdsCp.value = ids
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)) } catch { /* modo privado etc. */ }
}

export function setFlowCatalogCp(flows: Array<{ id: string; number: number }>): void {
  generalFlowIdCp.value = flows.find(f => f.number === GENERAL_FLOW_NUMBER)?.id ?? ''
  try { localStorage.setItem(GENERAL_STORAGE_KEY, generalFlowIdCp.value) } catch { /* modo privado etc. */ }
}

export function isFluxoHiddenCp(flowId: string | null | undefined): boolean {
  if (!flowId) return !!generalFlowIdCp.value && hiddenFluxoIdsCp.value.includes(generalFlowIdCp.value)
  return hiddenFluxoIdsCp.value.includes(flowId)
}
